"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var EventBindingBonusesListCtl = /** @class */ (function (_super) {
    __extends(EventBindingBonusesListCtl, _super);
    function EventBindingBonusesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_bonus_template_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_id; });
        _this.dk_bonus_template_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_title; });
        _this.dk_bonus_template_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_type_code; });
        _this.dk_bonus_template_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_template_type_title; });
        _this.dk_is_greater_or_eq_min_dep_amt_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_greater_or_eq_min_dep_amt_only; });
        _this.dk_min_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.min_deposit_amount; });
        _this.dk_is_lower_max_dep_amt_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_lower_max_dep_amt_only; });
        _this.dk_max_deposit_amount = UIUtils_1.UIUtils.IProp2Str(function (o) { o.max_deposit_amount; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this._errDialog = errDialog;
        return _this;
    }
    EventBindingBonusesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    EventBindingBonusesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "event binding bonuses with id [" + id + "] not found !";
    };
    EventBindingBonusesListCtl.prototype.LoadData = function (BonusSetId, onDone) {
        var _this = this;
        webAApi_1.ListBonusEventBindingsBonusesByEventBindingIdGet.exec({
            event_binding_id: BonusSetId,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    bonus_template_id: resp.list[i].bonus_template_id,
                    bonus_template_title: resp.list[i].bonus_template_title,
                    bonus_template_type_code: resp.list[i].bonus_template_type_code,
                    bonus_template_type_title: resp.list[i].bonus_template_type_title,
                    is_greater_or_eq_min_dep_amt_only: resp.list[i].is_greater_or_eq_min_dep_amt_only,
                    min_deposit_amount: resp.list[i].min_deposit_amount,
                    is_lower_max_dep_amt_only: resp.list[i].is_lower_max_dep_amt_only,
                    max_deposit_amount: resp.list[i].max_deposit_amount,
                    is_locked: resp.list[i].is_locked,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false)
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingBonusesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddBonusEventBindingBonus.exec({
            data: {
                event_binding_id: data.event_binding_id,
                bonus_template_id: data.bonus_template_id,
                is_greater_or_eq_min_dep_amt_only: data.is_greater_or_eq_min_dep_amt_only,
                min_deposit_amount: data.min_deposit_amount,
                is_lower_max_dep_amt_only: data.is_lower_max_dep_amt_only,
                max_deposit_amount: data.max_deposit_amount,
                is_locked: data.is_locked,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                bonus_template_id: data.bonus_template_id,
                bonus_template_title: resp.bonus_template_title,
                bonus_template_type_code: resp.bonus_template_type_code,
                bonus_template_type_title: resp.bonus_template_type_title,
                is_greater_or_eq_min_dep_amt_only: data.is_greater_or_eq_min_dep_amt_only,
                min_deposit_amount: data.min_deposit_amount,
                is_lower_max_dep_amt_only: data.is_lower_max_dep_amt_only,
                max_deposit_amount: data.max_deposit_amount,
                is_locked: data.is_locked,
                date_added: moment(resp.date_added_uts_ms).utc(false),
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                description: data.description
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    EventBindingBonusesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditBonusEventBindingBonus.exec({
                data: {
                    event_binding_bonus_id: data.key,
                    bonus_template_id: data.bonus_template_id,
                    is_greater_or_eq_min_dep_amt_only: data.is_greater_or_eq_min_dep_amt_only,
                    min_deposit_amount: data.min_deposit_amount,
                    is_lower_max_dep_amt_only: data.is_lower_max_dep_amt_only,
                    max_deposit_amount: data.max_deposit_amount,
                    is_locked: data.is_locked,
                    description: data.description
                }
            }, function (resp) {
                _tmp.bonus_template_id = data.bonus_template_id;
                _tmp.bonus_template_title = resp.bonus_template_title;
                _tmp.is_greater_or_eq_min_dep_amt_only = data.is_greater_or_eq_min_dep_amt_only;
                _tmp.min_deposit_amount = data.min_deposit_amount;
                _tmp.is_lower_max_dep_amt_only = data.is_lower_max_dep_amt_only;
                _tmp.max_deposit_amount = data.max_deposit_amount;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingBonusesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    EventBindingBonusesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteBonusEventBindingBonus.exec({ data: { event_binding_bonus_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    EventBindingBonusesListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetBonusEventBindingBonusIsLocked.exec({ data: { event_binding_bonus_id: key, locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return EventBindingBonusesListCtl;
}(BaseController_1.BaseController));
exports.EventBindingBonusesListCtl = EventBindingBonusesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_events_bindings/ctl/EventBindingBonusesListCtl.ts
// module id = 457
// module chunks = 0